import { ApiCulture, LanguageCode } from '@core/models';

export const LANGUAGE_STORAGE_KEY = 'spendkeep.language';

export function normalizeLanguage(language: string | null | undefined): LanguageCode {
  return language?.toLowerCase().startsWith('ro') ? 'ro' : 'en';
}

export function resolveInitialLanguage(): LanguageCode {
  const fromStorage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  if (fromStorage) {
    return normalizeLanguage(fromStorage);
  }

  const browserLanguage = navigator.languages?.[0] ?? navigator.language ?? 'en';
  return normalizeLanguage(browserLanguage);
}

export function apiCultureFor(language: LanguageCode): ApiCulture {
  return language === 'ro' ? 'ro-RO' : 'en-US';
}

export function commonTranslationFallback(
  key: 'connectionError' | 'genericError' | 'loggingOut' | 'serverError'
): string {
  const english = {
    connectionError: 'Unable to connect to server! Please try again.',
    genericError: 'Something went wrong!',
    loggingOut: 'Logging out...',
    serverError: 'Server error',
  };
  const romanian = {
    connectionError: 'Nu se poate conecta la server. Te rugam sa incerci din nou.',
    genericError: 'Ceva nu a mers bine!',
    loggingOut: 'Se face deconectarea...',
    serverError: 'Eroare de server',
  };

  return (resolveInitialLanguage() === 'ro' ? romanian : english)[key];
}
